import { CalendarDays } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { EnhancedContentCalendar } from "./EnhancedContentCalendar";

interface Props {
  onSchedulePost: (date: Date) => void;
}

export function ContentCalendarPage({ onSchedulePost }: Props) {
  return (
    <div>
      <PageHeader
        icon={CalendarDays}
        title="Content Calendar"
        description="Visualise your entire publishing schedule at a glance. Drag posts to reschedule, spot gaps in coverage, and plan your content weeks ahead across all platforms and channels."
      />
      <EnhancedContentCalendar onSchedulePost={onSchedulePost} showHeader={false} />
    </div>
  );
}
